// Utility function to merge classNames

import { cn } from "~/lib/utils";

interface ContainerProps {
  htmlFor?: "slider" | "wider" | "ultra-wide" | "fluid" | "max-wide";
  type?: "dark" | "teal" | "unique-teal";
  className?: string;
  children: React.ReactNode;
}

export default function Container({
  htmlFor,
  type,
  className,
  children,
}: ContainerProps) {
  const maxWidthClasses = {
    slider: "max-w-[1380px]",
    wider: "max-w-[1480px]",
    "ultra-wide": "max-w-[1600px]",
    "max-wide": "max-w-[1920px]",
    fluid: "max-w-full",
    default: "max-w-[1250px]",
  };

  const backgroundClasses = {
    dark: "bg-gray-200 p-5 md:p-12 lg:p-15",
    teal: "bg-teal-100 p-5 md:p-12 lg:p-15",
    "unique-teal": "bg-teal-200 p-5 md:p-12 lg:p-15",
    default: "",
  };

  const responsivePadding =
    htmlFor === "fluid" ? "px-0" : "px-0 md:px-16 lg:px-15";

  return (
    <div
      className={cn(
        "relative w-full mx-auto space-y-2 md:space-y-4 lg:space-y-5",
        maxWidthClasses[htmlFor || "default"],
        backgroundClasses[type || "default"],
        responsivePadding,
        className,
      )}
    >
      {children}
    </div>
  );
}
